// Needed to keep Immer happy.
import {enableMapSet as immerEnableMapSet} from 'immer';
immerEnableMapSet();

// This is needed to keep our outdated segment integration library happy.
if (typeof (window as any).global === 'undefined') {
  (window as any).global = window;
}
